module.exports = __webpack_public_path__ + "static/media/1 36 sove.98f8806c.mp3";